import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';

const Admin = () => {
    const { user, isAuthenticated } = useAuth0();
    const navigate = useNavigate();
    const serverName = "https://api.myemployeemanual.com";

    async function updateUser(e) {
        e.preventDefault();
        
        // Get form data
        const formData = new FormData(e.target);
        const userID = formData.get('userID');
        const docID = formData.get('docID');
        
        const response = await fetch(`${serverName}/pushManual?senderID=${user.sub}&userID=${userID}&manualID=${docID}`, {
            method: 'POST',
        });
        const data = await response.json();
        console.log(data);
    }
    return (
        <div>
            <form onSubmit={updateUser}>
                <input 
                    type='text' 
                    name='userID'
                    placeholder='What user ID do you want to confirm?'
                />
                <input 
                    type='text' 
                    name='docID'
                    placeholder='What manual ID do you want to confirm?'
                />
                <button type='submit'>Confirm</button>
            </form>
        </div>
    );
}

export default Admin;